
import clsx from "clsx";
import customStyles from "../../../../assets/styles/customStyles";


export default function SearchText() {
    const classes = customStyles();
    return <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>Sorry, no matches found</p>
}